import { useNavigationSearch as coreUseNavigationSearch } from '@shopware/composables'
import type { Schemas } from '#shopware'

export type SeoUrlRedirect = {
    url: string
    statusCode: number
    external: boolean
    originalPath?: string
}

export type ResolvePathResult = {
    seoUrl: Schemas['SeoUrl'] | null
    redirect: SeoUrlRedirect | null
}

export function useNavigationSearch() {
    const core = coreUseNavigationSearch()
    const { apiClient } = useShopwareContext()
    const { sessionContext } = useSessionContext()

    async function resolvePath(path: string): Promise<ResolvePathResult> {
        if (path === '/') {
            return {
                seoUrl: {
                    routeName: 'frontend.navigation.page',
                    foreignKey: sessionContext.value?.salesChannel?.navigationCategoryId,
                } as Schemas['SeoUrl'],
                redirect: null,
            }
        }

        const isTechnicalUrl =
            path.startsWith('/navigation/') ||
            path.startsWith('/detail/') ||
            path.startsWith('/landingPage/')
        const normalizedPath = isTechnicalUrl ? path : path.substring(1)

        const result = await apiClient.invoke('readSeoUrl post /seo-url', {
            body: {
                filter: [{
                    type: 'equals',
                    field: isTechnicalUrl ? 'pathInfo' : 'seoPathInfo',
                    value: normalizedPath,
                }],
            },
        })

        const extensions = (result.data as Record<string, unknown>)?.extensions as { redirect?: SeoUrlRedirect } | undefined

        return {
            seoUrl: result.data.elements?.[0] ?? null,
            redirect: extensions?.redirect ?? null,
        }
    }

    return {
        ...core,
        resolvePath,
    }
}
